import React, {Component} from "react";
import goldFinger from "../../../assets/img/goldFingers.png";

class GoldFingers extends Component {

    render() {
        return (
            <div className="container-fluid">
                <p> 表面処理オプションでENIGを選択された場合は金メッキで仕上がります。
                </p>
                <p> HASLを選択された場合はHASL（有鉛はんだレベラー）で仕上がります。
                </p>
                <div>
                    <img src={goldFinger} className="img-div" />
                </div>
            </div>
        );
    }
}

export default GoldFingers;


// WEBPACK FOOTER //
// ./src/components/Site/QuotationForm/GoldFingers.js